<template>
  <div>
    <v-card color="basil" class="basil-module-box">
      <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
        <v-tab
          v-for="(AllRole, i) in AllRoles"
          :key="i"
          @click="getroleModule(AllRole.role)"
          >{{ AllRole.role }}
          <input
            style="margin-left 1rem;"
            type="checkbox"
            v-model="AllRole.status"
            :value="true"
            @click="toggleRole(AllRole)"
          />
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" class="active-module-tab active-module-box">
        <v-tab-item v-for="(AllRole, i) in AllRoles" :key="i">
          <v-card color="basil" flat>
            <v-card-text>
              <button
                style="margin-left: 1rem; color: blue"
                @click="addNew = true"
              >
                Add
              </button>
              <v-container>
                <div v-if="roleFeatures">
                  <div
                    v-for="(val, roleFeature, i) in roleFeatures"
                    :key="i"
                    class="custom-control custom-switch"
                  >
                    <input
                      :id="'role-toggle-' + i"
                      :disabled="
                        !permissions.includes('CAN_CHANGE_VIEW_ACTIVE_MODULE')
                      "
                      v-model="roleFeatures[roleFeature]"
                      type="checkbox"
                      class="custom-control-input"
                      @click="confirmationModel(roleFeature, val, roleFeatures)"
                    />
                    <label
                      class="custom-control-label text-capitalize"
                      :for="'role-toggle-' + i"
                      >{{ roleFeature }}</label
                    >
                  </div>
                </div>
                <!-- <div>{{features}}</div> -->
              </v-container>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <v-dialog persistent v-model="addNew" width="700">
      <v-card class="min-height">
        <v-card-title class="headline grey lighten-2">ADD</v-card-title>
        <v-card-text>
          <CCol sm="12" class="p-0">
            <input
              type="text"
              v-model="newFeature"
              class="form-control"
              placeholder="Enter feature"
            />
          </CCol>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" class="mr-3 fsddf" @click="addNew = false"
            >Cancel</v-btn
          >
          <v-btn color="success" :disabled="loading" @click="addNewFeature"
            >Add</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import config from "@/config.js";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },
  data() {
    return {
      roleName: "",
      tab: null,
      AllRoles: [],
      selected: [],
      roleFeatures: {},
      addNew: false,
      loading: false,
      newFeature: "",
    };
  },
  created() {
    this.getActiveRoles();
    this.getroleModule("patient");
  },
  methods: {
    // get active role api
    getActiveRoles() {
      let url = `${config.BASE_URL}api/v2/admin/active-roles`;
      this.$http.get(url).then((response) => {
        if (response.body.status) {
          this.AllRoles = response.body.data.data;
        }
      });
    },

    // get role modules api
    getroleModule(roleData) {
      this.roleFeatures = {};
      this.roleName = roleData;
      let url = `${config.BASE_URL}api/v2/admin/features-by-role/${this.roleName}`;
      this.$http.get(url).then((response) => {
        if (response.body.status) {
          this.roleFeatures = this.flattenObject(
            response.body.data.data.features
          );
        }
      });
    },
    confirmationModel(key, value, selectData) {
      this.$swal({
        title: "Are you sure?",
        text: !selectData[key] ? "you want to activate this feature ?" :"you want to deactivate this feature?" ,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          this.toggleOption(key, value, selectData);
        }else{
          this.roleFeatures[key] = !selectData[key]
        }
      });
    },
    toggleOption(key, value, selectData) {
      let sendObj = {
        features: this.unflattenObject(selectData),
      };
      let url = `${config.BASE_URL}api/v2/admin/features-by-role/${this.roleName}`;
      this.$http.put(url, sendObj).then((response) => {
        if (response.body.status) {
          // this.AllRoles = response.body.data.data;
          this.getroleModule(this.roleName);
        }
      });
    },
    toggleRole(data) {
      let title = "Are you sure you want to enable this role ?";
      let html = "";
      if (data.status) {
        title = "Are you sure you want to disable this role ?";
        html = "<p>If yes then it will logout all logged in users . </p>";
      }
      this.$swal({
        title: title,
        html: html,
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        cancelButtonColor: "#f00",
        type: "warning",
        allowOutsideClick: false,
      }).then((setPass) => {
        if (setPass.value) {
          console.log(data.status);
          let url = `${config.BASE_URL}api/v2/admin/toggle-role-status`;
          this.$http
            .put(url, { role: data.role, status: data.status })
            .then((response) => {});
        } else {
          this.getActiveRoles();
          return false;
        }
      });
    },
    flattenObject(data) {
      var result = {};
      function recurse(cur, prop) {
        if (Object(cur) !== cur) {
          result[prop] = cur;
        } else if (Array.isArray(cur)) {
          for (var i = 0, l = cur.length; i < l; i++)
            recurse(cur[i], prop + "[" + i + "]");
          if (l == 0) result[prop] = [];
        } else {
          var isEmpty = true;
          for (var p in cur) {
            isEmpty = false;
            recurse(cur[p], prop ? prop + "." + p : p);
          }
          if (isEmpty && prop) result[prop] = {};
        }
      }
      recurse(data, "");
      return result;
    },

    unflattenObject(data) {
      "use strict";
      if (Object(data) !== data || Array.isArray(data)) return data;
      var regex = /\.?([^.\[\]]+)|\[(\d+)\]/g,
        resultholder = {};
      for (var p in data) {
        var cur = resultholder,
          prop = "",
          m;
        while ((m = regex.exec(p))) {
          cur = cur[prop] || (cur[prop] = m[2] ? [] : {});
          prop = m[2] || m[1];
        }
        cur[prop] = data[p];
      }
      return resultholder[""] || resultholder;
    },
    addNewFeature() {
      this.roleFeatures[this.newFeature] = false;
      let sendObj = {
        features: this.unflattenObject(this.roleFeatures),
      };
      let url = `${config.BASE_URL}api/v2/admin/features-by-role/${this.roleName}`;
      this.$http.put(url, sendObj).then((response) => {
        if (response.body.status) {
          this.getroleModule(this.roleName);
          this.addNew = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* Helper classes */
/* .basil {
  background-color: #92daaa !important;
} */
.basil--text {
  color: #92daaa !important;
}
.active-module-tab {
  .custom-switch {
    padding-left: 3.25rem;
    .custom-control-label {
      &:after {
        left: calc(-3.25rem + 2px);
      }
      &:before {
        left: -3.25rem;
      }
    }
  }
}
</style>